export default [
  {
    path: "/",
    component: () => import("../layouts/Auth.vue"),
    children: [
      {
        path: "login",
        name: "login-with-password",
        component: () =>
          import(
            /* webpackChunkName: "login-with-password" */ "../LoginWithPassword.vue"
          ),
      },
      {
        path: "register",
        name: "register-with-password",
        component: () =>
          import(
            /* webpackChunkName: "register-with-password" */ "../RegisterWithPassword.vue"
          ),
      },
      {
        path: "forgot-password",
        name: "forgot-password",
        component: () =>
          import(
            /* webpackChunkName: "forgot-password" */ "../ForgotPassword.vue"
          ),
      },
      {
        path: "forgot-password/change-password",
        name: "change-password",
        component: () => import("../ChangePassword.vue"),
      },
      {
        path: "account-active",
        name: "account-active",
        component: () =>
          import(
            /* webpackChunkName: "forgot-password" */ "../ActivateAccount.vue"
          ),
      },
    ],
  },
];
